const EXPIRED_TIME = 30 * 60 * 1000;
const KEY = 'security-alarm-data';

/**
 * 시큐리티 알람 전용 레퍼
 * @param fetcherFn 알람 패치 함수
 * @param userId 사용자 아이디 / 식별자로 사용
 * @returns {Promise<*|null>}
 */
export const loadSecurityAlarmWrapper = async (fetcherFn, userId) => {
  if (!userId) return null;

  const securityAlarmData = window.sessionStorage?.getItem(KEY) || null;

  try {
    if (securityAlarmData) {
      const parsed = JSON.parse(securityAlarmData);

      if (parsed?.expire && +parsed.expire >= new Date().getTime() && userId === parsed.userId) {
        if (Array.isArray(parsed.data)) {
          return parsed.data;
        }

        return JSON.parse(parsed.data);
      }
    }

    try {
      const expire = new Date().getTime() + EXPIRED_TIME;
      const result = await fetcherFn();

      const data = result?.data?.data;

      window.sessionStorage?.setItem(
        KEY,
        JSON.stringify({
          userId,
          data,
          expire,
        }),
      );

      return data;
    } catch (error) {
      console.error(error);
    }
  } catch (error) {
    console.error(error);
  }

  return null;
};
